import { requireContractAccess } from '@/lib/route-guards';
import { registryItemQueryOptions } from '@/queryOptions';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/rental-contracts/$rentalContractId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    version: search.version as string | undefined,
  }),
  context: ({ params }) => ({
    getBreadcrumbData: () => ({
      id: params.rentalContractId,
      translationKey: null,
    }),
  }),
  beforeLoad: ({ params, context, search }) => {
    requireContractAccess(context);
    return context.queryClient.ensureQueryData(registryItemQueryOptions(params.rentalContractId, search.version));
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Rental Contract Details - OPAZ E-Service Portal',
        },
      ],
    };
  },
});
